const EmailVerificationSent = () => {
  return (
    <div className="email-verification-sent">
      <h1>Email Verification Sent</h1>
      <p>
        A verification email has been sent to your email address. Please check
        your inbox (and spam folder) for the verification email.
      </p>
    </div>
  );
};

export default EmailVerificationSent;
